import {
  Component, ChangeDetectionStrategy, Input, HostBinding,
} from '@angular/core'

@Component({
  selector: 'kb-progress-indicator',
  templateUrl: './progress-indicator.component.html',
  styleUrls: ['./progress-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ProgressIndicatorComponent {
  @HostBinding('attr.design')
  @Input() public design: 'circular' | 'linear' = 'circular' as const

  @Input() public type: 'indeterminate' /* | 'determinate' */ = 'indeterminate' as const // determinate not yet implemented / needed
  @Input() public background: 'light' | 'dark' | 'mixed' = 'light'

  @HostBinding('attr.visible')
  @Input() public visible = true
}
